import { Client } from '../brand/client';
import { Distributeur } from '../brand/distributeur';
import { Parcours } from '../brand/parcours';
export class Brand {
  espace_distributeur: Distributeur;
  parcours_souscription: Parcours;
  espace_client: Client;
}
